<template>
  <div>
    <div v-if="average != 'N/A'">
      <v-chip class="mt-3 ml-1 pl-0" v-for="option in options" :key="option[0]">
        <v-chip class="mr-1" smalll :color="option[2]" text-color="white">
          {{ option[0] }}
        </v-chip>
        {{ option[1] }}
      </v-chip>
      <div v-for="type in types" :key="type">
        <v-simple-table class="align-start overflow-x: scroll" wide>
          <thead>
            <tr>
              <th class="text-h6">{{ type }}</th>
              <th v-for="date in dates" :key="date" class="text-h6">
                {{
                  grading_periods.find(
                    (gp) => gp.end_date.substr(0, 10) == date.substr(0, 10)
                  ).name
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="name in getAssessmentNames(type)" :key="name">
              <td>{{ name }}</td>
              <td v-for="date in dates" :key="date">
                <v-chip
                  text-color="white"
                  :color="options[getScore(name, date)][2]"
                >
                  {{ options[getScore(name, date)][0] }}
                </v-chip>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    grades: {
      type: Array,
      required: true,
    },
    assessments: {
      type: Array,
      required: true,
    },
    average: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    options: {
      1: ["1", "Significantly Below Grade Level", "red"],
      2: ["2", "Below Grade Level", "orange"],
      3: ["3", "At Grade Level", "green"],
      4: ["4", "Above Grade Level", "purple"],
      "": ["NG", "Not Graded", "grey"],
    },
    grading_periods: [],
  }),
  computed: {
    weights() {
      return this.assessments
        .filter((a) => this.getScore(a) !== false && !this.isExcluded(a))
        .map((a) => a.weight);
    },
    points() {
      return this.assessments
        .filter((a) => this.getScore(a) !== false && !this.isExcluded(a))
        .map((a) => this.getPoint(a));
    },
    types() {
      return this.assessments
        .map((a) => a.type)
        .filter((value, index, self) => self.indexOf(value) === index);
    },
    dates() {
      return this.assessments
        .map((a) => a.date)
        .filter((value, index, self) => self.indexOf(value) === index);
    },
  },
  methods: {
    getScore(name, date) {
      let ind = this.assessments.findIndex(
        (a) => a.name == name && a.date.substr(0, 10) == date.substr(0, 10)
      );
      console.log(name, date, ind);
      if (ind < 0) {
        return "";
      }
      let ind2 = this.grades.findIndex(
        (gr) => gr.assessment_id == this.assessments[ind].id
      );
      if (ind2 < 0) {
        return "";
      }
      return this.grades[ind2].score;
    },
    getAssessmentNames(type) {
      return this.assessments
        .filter((a) => a.type == type)
        .map((a) => a.name)
        .reduce(
          (unique, item) =>
            unique.includes(item) ? unique : [...unique, item],
          []
        );
    },
  },
  mounted() {
    this.$sisApi("get", "my-schedule/grading-periods")
      .then((response) => {
        this.grading_periods = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>
